import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/**
 * A collection of utilities to help connect to the platform
 */
import ClientContext from "./client-context/ClientContext";
/**
 * Creates the limitless public API URL based on environment variables.
 *
 * @param {string} path
 */

var createPublicUrl = function createPublicUrl(path) {
  var publicUrl = "".concat(process.env.REACT_APP_BASE_PLATFORM_URL).concat(process.env.REACT_APP_STAGE, "/public/").concat(path);
  return encodeURI(publicUrl);
};
/**
 * Creates the limitless public API URL based on environment variables.
 *
 * @param {string} path
 */


var createIntegrationUrl = function createIntegrationUrl(path) {
  var integrationUrl = "".concat(process.env.REACT_APP_BASE_PLATFORM_URL).concat(process.env.REACT_APP_STAGE, "/integration/").concat(path);
  return encodeURI(integrationUrl);
};
/**
 * Creates the headers needed for a mution AJAX call (POST/PUT)
 *
 * @param {string} additionalParams
 * @param {string} additionalHeaders
 */


var createPublicHeaders = function createPublicHeaders() {
  var additionalParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var additionalHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    headers: _objectSpread({
      "x-api-key": ClientContext._apiKey
    }, additionalHeaders),
    timeout: parseInt(process.env.REACT_APP_HTTP_POST_TIMEOUT),
    params: _objectSpread({}, additionalParams)
  };
};

export var createPublicAPIRequest = function createPublicAPIRequest(method, urlPath, queryParams, data, headers) {
  var isIntegration = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return _objectSpread({
    method: method,
    url: isIntegration ? createIntegrationUrl(urlPath) : createPublicUrl(urlPath)
  }, createPublicHeaders(queryParams, headers), {
    data: data
  });
};